$(function () {
    if (!$('#lastensuojeluForm').length) {
        return;
    }

    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang || 'fi';
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    let prefix;
    switch (language) {
        case "is-en":
        case "is":
            prefix = "youpret_iceland";
            break;
        case "ee":
        case "ee-en":
        case "ee-ru":
        case "et":
            prefix = "youpret_estonia";
            break;
        default:
            prefix = "youpret";
    }

    $.ajaxSetup({
        headers: {
            "X-TimeZoneName": timeZoneName,
            "X-Language": language,
            "X-Prefix": prefix
        },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });

    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: (() => {
            switch (language) {
                case "fi":
                    return "/fi/kiitos-yhteys/";
                case "en":
                    return "/en/thank-you-contact-form/";
                case "de":
                    return "/de/danke-kontaktformular/";
                case "sv":
                    return "/sv/tack-kontaktformularet/";
                case "ru":
                    return "/ru/spasibo-forma-obratnoy-svyazi/";
                case "is-en":
                    return "/is-en/thank-you-contact-form/";
                case "is":
                    return "/is/takk-fyrir-hafdu-samband/";
                case "ee-en":
                    return "/ee-en/thank-you-contact-form/";
                case "ee":
                case "et":
                    return "/ee/aitah/";
                default:
                    return "/fi/kiitos-yhteys/";
            }
        })(),
        uri: window.location.pathname
    };

    $("#lastensuojeluForm").on("submit", function (event) {
        event.preventDefault();
        if ($('#lastensuojeluForm')[0].checkValidity()) {
            $("#lastensuojeluSendBtn").prop("disabled", true);
            $("#lastensuojeluSendBtn").css("background-color", "#6c757d");

            let firstName = $("#lastensuojeluFirstName").val();
            let lastName = $("#lastensuojeluLastName").val();
            let email = $("#lastensuojeluEmail").val();
            let phoneNumber = $("#lastensuojeluPhoneNumber").val() || "";
            let organization = $("#lastensuojeluOrganization").val() || "";
            let message = $("#lastensuojeluMessage").val() || "";

            let infoParts = [];
            if (organization) {
                infoParts.push("Organisaatio: " + organization);
            }
            if (message) {
                infoParts.push("Lisätietoja: " + message);
            }

            let data = {
                email: email,
                firstName: firstName,
                lastName: lastName,
                phoneNumber: phoneNumber,
                organizationName: organization,
                additionalInformation: infoParts.length > 0 ? infoParts.join("\n") : message,
                competitionName: "lastensuojelupaivat2026Form",
                uri: Uris.uri,
                languageCode: language,
                code: ""
            };

            getRecaptchaToken().then(function (token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function () {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function (err) {
                    console.error(err);
                    $("#lastensuojeluSendBtn").prop("disabled", false);
                    $("#lastensuojeluSendBtn").css("background-color", "#28a745");
                });
            });
        } else {
            $('#lastensuojeluForm')[0].reportValidity();
        }
    });

    function toggleSendButtonState() {
        const formValid = $('#lastensuojeluForm')[0].checkValidity();

        if (formValid) {
            $("#lastensuojeluSendBtn").prop("disabled", false);
            $("#lastensuojeluSendBtn").css("background-color", "#28a745");
        } else {
            $("#lastensuojeluSendBtn").prop("disabled", true);
            $("#lastensuojeluSendBtn").css({
                "background-color": "#6c757d",
                "border": "none",
                "outline": "none"
            });
        }
    }

    $('#lastensuojeluForm input, #lastensuojeluForm textarea').on('input change', toggleSendButtonState);

    toggleSendButtonState();
});
